import { useEffect } from 'react';

import { useCashCount } from '../../hooks/cash/useCashCount';
import { useCashSession } from '../../hooks/cash/useCashSession';

import CashSessionHeader from '../CashStatus/CashSessionHeader';
import CashSessionStats from '../CashStatus/CashSessionStats';
import CashSessionFooter from '../CashStatus/CashSessionFooter';
import EmptyCashSessionState from '../CashStatus/EmptyCashSessionState';

const CashCountSessionCard = () => {
  const { auditStarted, start, complete } = useCashCount();

  const { activeSession, getActiveSession } = useCashSession();

  useEffect(() => {
    if (!activeSession) {
      getActiveSession();
    }
  }, []);

  if (!activeSession) {
    return <EmptyCashSessionState />;
  }

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <CashSessionHeader
        onAction={auditStarted ? complete : start}
        actionLabel={auditStarted ? 'Finalizar Arqueo' : 'Iniciar Arqueo'}
        actionColor={auditStarted ? '#28A745' : '#0D6EFD'}
      />

      <CashSessionStats
        registerName={activeSession.registerName}
        userName={activeSession.openedByName}
        openingTime={activeSession.openedAt}
      />

      <CashSessionFooter currentBalance={activeSession.currentBalance} />
    </div>
  );
};

export default CashCountSessionCard;
